/**
 * Main layout wrapper for the authenticated admin dashboard.
 *
 * Uses shadcn SidebarProvider for sidebar state management.
 * The sidebar state is persisted via cookies (built into shadcn).
 *
 * @see /src/components/layout/Sidebar.tsx
 * @see https://ui.shadcn.com/docs/components/sidebar
 */

import { Outlet } from 'react-router-dom'
import { SidebarProvider, SidebarInset } from '@/components/ui/sidebar'
import { AppSidebar } from './Sidebar'
import Header from './Header'
import SkipNav from '@/components/accessibility/SkipNav'
import { Toaster } from '@/components/ui/toaster'

export default function MainLayout() {
  return (
    <SidebarProvider defaultOpen={true}>
      <div className="flex h-screen w-full">
        {/* Skip Navigation Links */}
        <SkipNav />

        {/* Sidebar Navigation */}
        <AppSidebar />

        {/* Main Content Area */}
        <SidebarInset className="flex flex-col flex-1 min-w-0">
          <Header />

          <main
            id="main-content"
            className="flex-1 overflow-auto p-4 sm:p-6"
            tabIndex={-1}
            role="main"
            aria-label="Main content"
          >
            <div className="max-w-7xl mx-auto">
              <Outlet />
            </div>
          </main>
        </SidebarInset>

        {/* Toast Notifications */}
        <Toaster />
      </div>
    </SidebarProvider>
  )
}
